export default __webpack_public_path__ + "images/bgpk5.db8fb01.jpg";